/* @flow */

const manufacturerRoutes = {
  addForUser: 'manufacturers/add-for-user',
  activity: 'manufacturers/:manufacturerGuid/activity',
};

export default manufacturerRoutes;
